export const environmentSelector = state => state.common.environment;